<template>
    <div class="wrap-input" :class="customClass">
        <label class="label"
               :class="{'error': !isFirstSave && isShowErrorLbl && !errorInfo.isValid}"
               :for="id">{{label}}</label>
        <div class="input-box">
            <input type="tel"
                   v-model="content"
                   class="input-field"
                   :class="{'error': !isFirstSave && isShowErrorLbl && !errorInfo.isValid}"
                   :id="id"
                   :maxlength="maxLength"
                   :readonly="readOnly"
                   @input="onChange()" />
            <div class="divider" :class="{'is-error': !isFirstSave && isShowErrorLbl && !errorInfo.isValid}"></div>
            <span class="placeholder"
                  :class="{'error': !isFirstSave && isShowErrorLbl && !errorInfo.isValid}"
                  v-show="!content">{{placeholder}}</span>
        </div>
        <div class="error-text"
             v-if="isShowErrorLbl"
             v-show="!isFirstSave && !errorInfo.isValid">{{errorInfo.msg}}</div>
    </div>
</template>
<script>
import Vue from 'vue';
import Util from '@/helper/Utility.js';
/**
 * Property
 * @property {string} inputId (required) Field id for emit.
 * @property {object} inputLbl (required) Text for component.
 * @property {number} inputMinLength (optional) Minimum length.
 * @property {number} inputMaxLength (optional) Maximum Length.
 * @property {boolean} isFirstSave (required) Show/Hide Error after save.
 * @property {boolean} isShowErrorLbl (optional) Show/Hide Error label.
 * @property {object} errorInfo (required) Validation status. example : { isValid: true, msg: '',}
 * @property {boolean} blockAutoComplete (optional) Block borwser auto complete field.
 * @property {string} addClass (optional) Add css class
 * Event
 * @event onChange Filter and validate.
 * Method
 * @method validateInput Validate text.
 */
export default {
    name: "Zipcode",
    props: {
        //v-model
        value: String,
        //props
        inputId: String,
        inputLbl: Object,
        inputMinLength: Number,
        inputMaxLength: Number,
        isFirstSave: Boolean,
        isShowErrorLbl: Boolean,
        errorInfo: Object,
        blockAutoComplete: Boolean,
        addClass: String,
    },
    data: function() {
        return {
            id: '',
            label: '',
            placeholder: '',
            content: this.value,
            minLength: 0,
            maxLength: 0,
            readOnly: true,
            customClass: '',
        };
    },
    mounted: function() {
        this.id = this.inputId;
        this.label = this.inputLbl.name;
        this.placeholder = this.inputLbl.placeholder;
        this.minLength = this.inputMinLength || null;
        this.maxLength = this.inputMaxLength || null;
        this.customClass = this.addClass || '';
        this.validateInput();

        this.readOnly = this.blockAutoComplete;
        setTimeout(() => {
            this.readOnly = false;
        }, 500);
    },
    methods: {
        validateInput: function () {
             if(!this.inputLbl) return;
             //Set default.
            this.errorInfo.isValid = true;
            this.errorInfo.msg = '';
            //Required
            if(this.inputLbl.required
                && !this.content) {

                this.errorInfo.isValid = false;
                this.errorInfo.msg = this.inputLbl.required;
                return;
            }
            //Too short
            if(this.inputLbl.too_short && this.maxLength
                && (this.content.length < this.maxLength)) {

                this.errorInfo.isValid = false;
                this.errorInfo.msg = Util.stringFormat(this.inputLbl.too_short, this.maxLength);
                return;
            }
            //InValid format
            if(this.inputLbl.invalid) {
                if(!Vue.validator.validateZipCode(this.content)) {

                    this.errorInfo.isValid = false;
                    this.errorInfo.msg = this.inputLbl.invalid;
                    return;
                }
            }
        },
        onZipcodeChange: function () {
            this.$emit("onZipcodeChange", {});
        },
        onChange: function() {
            var result = this.content;
            //Remove restrict character.
            result = result.replace(Vue.RegExp.emoji, '');
            result = result.replace(Vue.RegExp.notNumber, '');

            this.content = result;
            this.validateInput();
            this.$emit("input", result);

            this.onZipcodeChange();
        },
    },
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "@/style/Input/Text.scss";
.wrap-input {
    @extend %input-base;
}
</style>
